import React from 'react'
import styled from 'styled-components'

import { Box } from '../Grid'

import Visa from './Visa'
import Mastercard from './Mastercard'
import Amex from './Amex'
import Diners from './Diners'
import Discover from './Discover'
import JCB from './JCB'
import UnionPay from './UnionPay'

const Wrapper = styled(Box).attrs(props => ({
  borderColor: 'light-dark(var(--brand-grey-100), var(--brand-grey-500))',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '3px',
  height: 20,
  width: 32,
  ...props
}))`
  svg {
    width: auto;
    height: 100%;
  }
`

export const CARD_TYPES = {
  AMERICAN_EXPRESS: 'American Express',
  AMEX: 'amex',
  DINERS_CLUB: 'Diners Club',
  DISCOVER: 'Discover',
  JCB: 'JCB',
  UNIONPAY: 'UnionPay',
  MASTERCARD: 'MasterCard',
  VISA: 'Visa',
  UNKNOWN: 'Unknown'
}

const CreditCard = ({ type, ...props }) => {
  const Icon = type => {
    switch (type) {
      case CARD_TYPES.VISA:
      case CARD_TYPES.VISA.toLowerCase():
        return Visa
      case CARD_TYPES.MASTERCARD:
      case CARD_TYPES.MASTERCARD.toLowerCase():
        return Mastercard
      case CARD_TYPES.AMERICAN_EXPRESS:
      case CARD_TYPES.AMERICAN_EXPRESS.toLowerCase():
      case CARD_TYPES.AMEX:
        return Amex
      case CARD_TYPES.DINERS_CLUB:
      case CARD_TYPES.DINERS_CLUB.toLowerCase():
        return Diners
      case CARD_TYPES.DISCOVER:
      case CARD_TYPES.DISCOVER.toLowerCase():
        return Discover
      case CARD_TYPES.JCB:
      case CARD_TYPES.JCB.toLowerCase():
        return JCB
      case CARD_TYPES.UNIONPAY:
      case CARD_TYPES.UNIONPAY.toLowerCase():
        return UnionPay
      default:
        return null
    }
  }

  const Component = Icon(type)

  return <Wrapper {...props}>{!Component || <Component />}</Wrapper>
}

export default CreditCard
